var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _g, _rect4, _g2, _rect5, _g3, _rect6, _g4, _rect7, _g5, _rect8, _g6, _rect9, _g7, _rect10, _rect11, _g8, _rect12, _g9, _rect13, _g10, _rect14, _g11, _rect15, _g12, _rect16, _g13, _rect17, _g14, _rect18, _rect19, _g15, _rect20, _g16, _rect21, _g17, _rect22, _g18, _rect23, _g19, _rect24, _g20, _rect25, _g21, _rect26, _rect27, _g22, _rect28, _g23, _rect29, _g24, _rect30, _g25, _rect31, _g26, _rect32, _g27, _rect33, _g28, _rect34, _rect35, _g29, _rect36, _g30, _rect37, _g31, _rect38, _g32, _rect39, _g33, _rect40, _g34, _rect41, _g35, _rect42, _rect43, _g36, _rect44, _g37, _rect45, _g38, _rect46, _g39, _rect47, _g40, _rect48, _g41, _rect49, _g42, _path7, _g43, _path8, _g44;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDataViewGraphs = function SvgDataViewGraphs(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 99,
    viewBox: "0 0 160 99",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 98,
    rx: 2.5,
    fill: "white",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 62.967L148.451 62.9358",
    stroke: "currentColor",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 56.0664L148.451 56.0351",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 84.8894H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 73.9282H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 79.4089H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 68.4328H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 58,
    width: 13,
    height: 3
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 58.8418,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 58.8418,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 57.3193,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 58,
    width: 11,
    height: 3
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 58.8418,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 57.3193,
    width: 16.3403,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 58,
    width: 14,
    height: 3
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 58.8418,
    width: 13.194,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 57.3193,
    width: 19.791,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 58,
    width: 8,
    height: 3
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 58.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 57.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 58,
    width: 8,
    height: 3
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 58.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 57.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 58,
    width: 14,
    height: 3
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 58.8418,
    width: 13.194,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 57.3193,
    width: 19.791,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 58,
    width: 7,
    height: 3
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 58.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 57.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 64,
    width: 13,
    height: 3
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 64.9313,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 64.9314,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 63.4089,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 64,
    width: 14,
    height: 3
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 64.9314,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 63.4089,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 64,
    width: 11,
    height: 3
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 64.9314,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 63.4089,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 64,
    width: 10,
    height: 3
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 64.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 63.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 64,
    width: 10,
    height: 3
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 64.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 63.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 64,
    width: 11,
    height: 3
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 64.9314,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 63.4089,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 64,
    width: 9,
    height: 3
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 64.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 63.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 70,
    width: 13,
    height: 2
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 70.412,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 70.4121,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 68.8896,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 70,
    width: 14,
    height: 2
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 70.4121,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 68.8896,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 70,
    width: 11,
    height: 2
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 70.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 68.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 70,
    width: 10,
    height: 2
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 70.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 68.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 70,
    width: 10,
    height: 2
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 70.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 68.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 70,
    width: 11,
    height: 2
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 70.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 68.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 70,
    width: 9,
    height: 2
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 70.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 68.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 75,
    width: 13,
    height: 3
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 75.994,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 75.9939,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 74.4717,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 75,
    width: 14,
    height: 3
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 75.9939,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 74.4717,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 75,
    width: 11,
    height: 3
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 75.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 74.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 75,
    width: 10,
    height: 3
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 75.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 74.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 75,
    width: 10,
    height: 3
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 75.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 74.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 75,
    width: 11,
    height: 3
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 75.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 74.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 75,
    width: 9,
    height: 3
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 75.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 74.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 81,
    width: 13,
    height: 2
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 81.4746,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 81.4746,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 79.9521,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 81,
    width: 14,
    height: 2
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 81.4746,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 79.9521,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 81,
    width: 11,
    height: 2
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 81.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 79.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 81,
    width: 10,
    height: 2
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 81.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 79.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 81,
    width: 10,
    height: 2
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 81.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 79.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 81,
    width: 11,
    height: 2
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 81.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 79.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 81,
    width: 9,
    height: 2
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 81.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 79.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 86,
    width: 13,
    height: 3
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 86.9552,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 86.9551,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 85.4329,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 86,
    width: 14,
    height: 3
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 86.9551,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 85.4329,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 86,
    width: 11,
    height: 3
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 86.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 85.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 86,
    width: 10,
    height: 3
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 86.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 85.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 86,
    width: 10,
    height: 3
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 86.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 85.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 86,
    width: 11,
    height: 3
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 86.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 85.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 86,
    width: 9,
    height: 3
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 86.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 85.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 62,
    height: 35
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3974 9.93908C70.452 9.91234 70.512 9.89844 70.5727 9.89844H76.565C76.7851 9.89844 76.9635 10.0769 76.9635 10.2969C76.9635 10.517 76.7851 10.6954 76.565 10.6954H70.6651L61.1378 15.363L61.129 15.3673L61.129 15.3672L51.3129 19.8814L40.9303 26.1474C40.8383 26.2029 40.7278 26.2189 40.6239 26.1918L30.1597 23.465L20.0155 29.6544C19.953 29.6926 19.8811 29.7128 19.8079 29.7128H15.3985C15.1784 29.7128 15 29.5343 15 29.3143C15 29.0942 15.1784 28.9158 15.3985 28.9158H19.6959L29.889 22.6965C29.9813 22.6402 30.0925 22.6238 30.197 22.6511L40.6623 25.3782L50.9202 19.1875C50.9329 19.1798 50.9461 19.1728 50.9596 19.1666L60.7915 14.6451L70.3974 9.93908ZM15.2854 35.2871C15.2854 35.0985 15.4383 34.9455 15.627 34.9455H23.9888C24.1774 34.9455 24.3304 35.0985 24.3304 35.2871V43.4664C24.3304 43.655 24.1774 43.808 23.9888 43.808H15.627C15.4383 43.808 15.2854 43.655 15.2854 43.4664V35.2871ZM26.0288 28.7603C25.8402 28.7603 25.6873 28.9132 25.6873 29.1019V43.3741C25.6873 43.5627 25.8402 43.7157 26.0288 43.7157H34.3907C34.5793 43.7157 34.7322 43.5627 34.7322 43.3741V29.1019C34.7322 28.9132 34.5793 28.7603 34.3907 28.7603H26.0288ZM36.3151 31.779C36.3151 31.5903 36.468 31.4374 36.6567 31.4374H44.7924C44.981 31.4374 45.1339 31.5903 45.1339 31.779V43.4663C45.1339 43.655 44.981 43.8079 44.7924 43.8079H36.6567C36.468 43.8079 36.3151 43.655 36.3151 43.4663V31.779ZM47.0583 25.1599C46.8697 25.1599 46.7167 25.3128 46.7167 25.5015V43.4664C46.7167 43.655 46.8697 43.8079 47.0583 43.8079H55.4201C55.6088 43.8079 55.7617 43.655 55.7617 43.4664V25.5015C55.7617 25.3128 55.6088 25.1599 55.4201 25.1599H47.0583ZM57.3446 20.8857C57.3446 20.697 57.4975 20.5441 57.6862 20.5441H66.048C66.2366 20.5441 66.3896 20.697 66.3896 20.8857V43.4664C66.3896 43.6551 66.2366 43.808 66.048 43.808H57.6862C57.4975 43.808 57.3446 43.6551 57.3446 43.4664V20.8857ZM68.0878 15.9283C67.8992 15.9283 67.7462 16.0813 67.7462 16.2699V43.4665C67.7462 43.6552 67.8992 43.8081 68.0878 43.8081H76.2235C76.4121 43.8081 76.5651 43.6552 76.5651 43.4665V16.2699C76.5651 16.0813 76.4121 15.9283 76.2235 15.9283H68.0878Z",
    fill: "#EDF3F6"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.066,
    y: 8.13823,
    width: 65.7392,
    height: 36.2591,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.113858
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1403_19120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 9,
    width: 63,
    height: 35
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.434 10.0362C138.489 10.0095 138.549 9.99561 138.609 9.99561H144.602C144.822 9.99561 145 10.174 145 10.3941C145 10.6142 144.822 10.7926 144.602 10.7926H138.702L129.174 15.4601L129.166 15.4644L129.166 15.4643L119.349 19.9785L108.967 26.2446C108.875 26.3001 108.764 26.3161 108.661 26.289L98.1964 23.5621L88.0521 29.7516C87.9896 29.7897 87.9178 29.8099 87.8445 29.8099H83.4351C83.215 29.8099 83.0366 29.6315 83.0366 29.4114C83.0366 29.1913 83.215 29.0129 83.4351 29.0129H87.7326L97.9256 22.7937C98.0179 22.7374 98.1291 22.721 98.2337 22.7482L108.699 25.4754L118.957 19.2846C118.97 19.2769 118.983 19.27 118.996 19.2638L128.828 14.7423L138.434 10.0362ZM83.322 35.3843C83.322 35.1956 83.4749 35.0427 83.6636 35.0427H92.0254C92.2141 35.0427 92.367 35.1956 92.367 35.3843V43.5636C92.367 43.7522 92.2141 43.9051 92.0254 43.9051H83.6636C83.4749 43.9051 83.322 43.7522 83.322 43.5636V35.3843ZM94.0655 28.8575C93.8768 28.8575 93.7239 29.0104 93.7239 29.199V43.4713C93.7239 43.6599 93.8768 43.8128 94.0655 43.8128H102.427C102.616 43.8128 102.769 43.6599 102.769 43.4713V29.199C102.769 29.0104 102.616 28.8575 102.427 28.8575H94.0655ZM104.352 31.8762C104.352 31.6875 104.505 31.5346 104.693 31.5346H112.829C113.018 31.5346 113.171 31.6875 113.171 31.8762V43.5635C113.171 43.7522 113.018 43.9051 112.829 43.9051H104.693C104.505 43.9051 104.352 43.7521 104.352 43.5635V31.8762ZM115.095 25.2571C114.906 25.2571 114.753 25.41 114.753 25.5986V43.5635C114.753 43.7522 114.906 43.9051 115.095 43.9051H123.457C123.645 43.9051 123.798 43.7522 123.798 43.5635V25.5986C123.798 25.41 123.645 25.2571 123.457 25.2571H115.095ZM125.381 20.9828C125.381 20.7942 125.534 20.6413 125.723 20.6413H134.085C134.273 20.6413 134.426 20.7942 134.426 20.9828V43.5636C134.426 43.7523 134.273 43.9052 134.085 43.9052H125.723C125.534 43.9052 125.381 43.7523 125.381 43.5636V20.9828ZM136.124 16.0255C135.936 16.0255 135.783 16.1784 135.783 16.3671V43.5637C135.783 43.7523 135.936 43.9053 136.124 43.9053H144.26C144.449 43.9053 144.602 43.7523 144.602 43.5637V16.3671C144.602 16.1784 144.449 16.0255 144.26 16.0255H136.124Z",
    fill: "#EDF3F6"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1403_19120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.1025,
    y: 8.23543,
    width: 65.7392,
    height: 36.2591,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.113858
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataViewGraphs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-view-graphs.20f3a2b8.svg";
export { ForwardRef as ReactComponent };